import React, { useEffect, useState } from "react";
import { createBrand } from "../../redux/actions/brandAction";
import { useDispatch, useSelector } from "react-redux";
import notify from "../../hook/useNotification";
import avatar from "../../Images/avatar.png";
import { getSettings } from "../../redux/actions/settingsAcions";
import { createContactUsGallery } from "../../redux/actions/contactUsGalleryAction";

const AdminAddContactusGalleryHook = () => {
  const dispatch = useDispatch();
  const [img, setImg] = useState(avatar);
  const [nameAr, setNameAr] = useState("");
  const [nameEn, setNameEn] = useState("");
  const [address, setaddress] = useState("");
  const [mobile, setmobile] = useState("");
  const [email, setemail] = useState("");

  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isPress, setIsPress] = useState(false);
  const onChangeNameAr = (e) => {
    setNameAr(e.target.value);
  };
  const onChangeNameEn = (e) => {
    setNameEn(e.target.value);
  };
  const onChangemobile = (e) => {
    setmobile(e.target.value);
  };
  const onChangeemail = (e) => {
    setemail(e.target.value);
  };
  const onChangeaddress = (e) => {
    setaddress(e.target.value);
  };

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0])
      setImg(URL.createObjectURL(event.target.files[0]));
    setSelectedFile(event.target.files[0]);
  };
  const handleSubmit = async (event) => {
    if (nameAr === "" || nameEn === "" || selectedFile === null) {
      notify("من فضلك اكمل البيانات", "warn");

      return;
    }
    event.preventDefault();
    const formData = new FormData();
    formData.append("city_name_ar", nameAr);
    formData.append("city_name_en", nameEn);
    formData.append("address", address);
    formData.append("mobile", mobile);
    formData.append("email", email);
    formData.append("logo", selectedFile);
    setIsPress(true);
    await dispatch(createContactUsGallery(formData));
    setLoading(false);
  };

  const settingsRes = useSelector((state) => state.settingsReducers.settings);
  const res = useSelector(
    (state) => state.contactUsGalleryReducer.contactUsGallery
  );

  useEffect(() => {
    if (loading === false) {
      setImg(avatar);
      setNameAr("");
      setNameEn("");
      setSelectedFile(null);
      setLoading(true);
      setTimeout(() => setIsPress(false), 1000);

      if (res.status === 201) {
        notify("تم الاضافة بنجاح", "success");
      } else {
        notify("فشل في عملية الاضافه", "error");
      }
    }
  }, [loading]);
  return [
    img,
    nameAr,
    nameEn,
    isPress,
    loading,
    handleSubmit,
    onImageChange,
    onChangeNameAr,
    onChangeNameEn,
    settingsRes,
    email,
    onChangeemail,
    address,
    onChangeaddress,
    mobile,
    onChangemobile,
  ];
};

export default AdminAddContactusGalleryHook;
